package com.eladfinish.bible.contest.ui.components.dialogs

import androidx.compose.foundation.layout.ColumnScope
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.close
import com.eladfinish.bible.contest.colorAccent
import com.eladfinish.bible.contest.ok
import dev.icerock.moko.resources.compose.colorResource
import dev.icerock.moko.resources.compose.localized
import dev.icerock.moko.resources.desc.desc

@Composable
fun ColumnScope.DialogPositiveButtonInColumn(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    DialogPositiveButton(
        onClick = onClick,
        modifier = modifier.align(alignment = Alignment.CenterHorizontally),
    )
}

@Composable
fun DialogPositiveButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    OutlinedButton(
        modifier = modifier,
        onClick = {
            onClick.invoke()
        },
        content = {
            Text(
                text = SharedRes.strings.ok.desc().localized(),
                color = colorResource(SharedRes.colors.colorAccent),
            )
        },
    )
}

@Composable
fun ColumnScope.DialogNegativeButtonInColumn(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    DialogNegativeButton(
        onClick = onClick,
        modifier = modifier.align(alignment = Alignment.CenterHorizontally),
    )
}

@Composable
fun DialogNegativeButton(
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    OutlinedButton(
        modifier = modifier,
        onClick = {
            onClick.invoke()
        },
        content = {
            Text(
                text = SharedRes.strings.close.desc().localized(),
                color = colorResource(SharedRes.colors.colorAccent),
            )
        },
    )
}
